import React, { useEffect, useState } from "react";
import "./CounterFactor.scss";
import ObjectDataHolder from "../Hooks/ObjectDataHolder";
import CounterFactorData from "./CounterFactorData";
import _axios from "../../httpService";
import CounterFactorKol from "./FactorKol/CounterFactorKol";
import CounterFactorJoz from "./FactorJoz/CounterFactorJoz";
import { prefixUrl } from "../../utils/utilsData";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import { useLocation } from "react-router-dom";
import { calculateSumOfEachRow } from "./Functions";
import { parseToEnRemoveComma } from "../../utils/CommaSeparator";

const CounterFactor = () => {
  const [sendData, setSendData] = ObjectDataHolder({});
  // console.log("sendData :::", sendData);
  const [initialData, setInitialData] = ObjectDataHolder({});
  const [componentData, setComponentData] = ObjectDataHolder({});
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  //وقتی دیتا بعد از ادیت میشینه

  useEffect(() => {
    if (location.state) {
      //edite mode
      _axios
        .get(prefixUrl() + `/counterOfficeFactor/?request=initialData`)
        .then((res) => {
          if (res.data.status) {
            setLoading(false);
            const iniData = { ...res.data };
            setInitialData(iniData); //دیتای کلی صفحه

            _axios
              .get(
                prefixUrl() +
                  `/counterOfficeFactor/?request=factorSubmitedData&id=${location.state.id}`
              )
              .then((res) => {
                if (res.data.status) {
                  setLoading(false);
                  const temp = { ...res.data };
                  const newData = { ...sendData, ...temp };
                  setSendData(newData);
                  setComponentData({ reloadTableData: Math.random() });
                } else {
                  toast.error(res.data.message);
                }
              });
          } else {
            toast.error("اینترنت خود را چک کنید");
          }
        });
    } else {
      //add mode
      _axios
        .get(prefixUrl() + `/counterOfficeFactor/?request=initialData`)
        .then((res) => {
          setSendData(CounterFactorData.initialSendData); //دیتای ارسالی سمت بک
          setComponentData(CounterFactorData.componentData);
          if (res.data.status) {
            setLoading(false);
            const iniData = { ...res.data };
            setInitialData(iniData); //دیتای کلی صفحه
          } else {
            toast.error("اینترنت خود را چک کنید");
          }
        });
    }
  }, []);

  useEffect(() => {
    //این یوزافکت برای زمانی که مود در حالت ادیت می باشد در نظر گرفته شده است
    const products = calculateSumOfEachRow(sendData?.productsTableData);
    const services = calculateSumOfEachRow(sendData?.servicesTableData);
    setSendData({ productsTableData: products, servicesTableData: services });
    const sumProduct = sendData?.productsTableData?.reduce(function (
      total,
      row
    ) {
      const newTotalSum = parseToEnRemoveComma(row.totalSum);
      const result = total + +newTotalSum;
      return result;
    },
    0);

    const sumService = sendData?.servicesTableData?.reduce(function (
      total,
      row
    ) {
      const newTotalSum = parseToEnRemoveComma(row.totalSum);
      const result = total + +newTotalSum;
      return result;
    },
    0);
    setComponentData({
      sumProductTotalInvoice: sumProduct,
      sumServiceTotalInvoice: sumService,
      reload: Math.random(),
    });
  }, [componentData?.reloadTableData]);

  useEffect(() => {
    // console.log(componentData);
    const totalOfTables =
      componentData?.sumProductTotalInvoice +
      componentData?.sumServiceTotalInvoice; //حمع جدول های کالا و خدمات
    const total = totalOfTables - parseToEnRemoveComma(sendData?.discount); //جمع کالاوخدمات منهای تخفیف
    const calculateTax = (total * initialData.tax) / 100; //محاسبه مالیات
    const totalFactor = total + calculateTax; //جمع کل فاکتور
    const remainOfFactor =
      totalFactor - parseToEnRemoveComma(sendData?.paidPrice); //محاسبه مانده فاکتور
    setSendData({
      sumOfProductsAndServices: totalOfTables,
      sumTotalInvoice: totalFactor,
      tax: calculateTax,
      invoiceBalance: remainOfFactor,
    });
  }, [componentData?.reload]);

  return (
    <>
      {loading === false ? (
        <div className="counterFactorWrapper__">
          <CounterFactorKol
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />
          <div className="tablesWrapper__">
            <CounterFactorJoz
              sendData={sendData}
              setSendData={setSendData}
              initialData={initialData}
              componentData={componentData}
              setComponentData={setComponentData}
            />
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default CounterFactor;
